export const BULK_PURCHASE_WALLET_PURCHASE_AMOUNT_CHANGED = 'BULK_PURCHASE_WALLET_PURCHASE_AMOUNT_CHANGED';
export const walletPurchaseAmountChanged = (jobGuid, walletProviderCost, amount) => ({
  type: BULK_PURCHASE_WALLET_PURCHASE_AMOUNT_CHANGED,
  jobGuid,
  walletProviderCost,
  amount,
});

export const BULK_PURCHASE_PROVIDER_PURCHASE_AMOUNT_CHANGED = 'BULK_PURCHASE_PROVIDER_PURCHASE_AMOUNT_CHANGED';
export const providerPurchaseAmountChanged = (jobGuid, provider, amount) => ({
  type: BULK_PURCHASE_PROVIDER_PURCHASE_AMOUNT_CHANGED,
  jobGuid,
  provider,
  amount,
});

export const BULK_PURCHASE_INSURANCE_PURCHASE_AMOUNT_CHANGED = 'BULK_PURCHASE_INSURANCE_PURCHASE_AMOUNT_CHANGED';
export const insurancePurchaseAmountChanged = (jobGuid, provider, amount) => ({
  type: BULK_PURCHASE_INSURANCE_PURCHASE_AMOUNT_CHANGED,
  jobGuid,
  provider,
  amount,
});

export const BULK_PURCHASE_START = 'BULK_PURCHASE_START';
export const startBulkPurchase = (fulfillmentPlanIds, andPrint) => ({
  type: BULK_PURCHASE_START,
  fulfillmentPlanIds,
  andPrint,
});

export const BULK_PURCHASE_VALIDATE_END = 'BULK_PURCHASE_VALIDATE_END';
export const endValidate = (includedFulfillmentPlanIds, excludedFulfillmentPlanIds, erroredFulfillmentPlanIds, andPrint) => ({
  type: BULK_PURCHASE_VALIDATE_END,
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  erroredFulfillmentPlanIds,
  andPrint,
});

export const BULK_PURCHASE_COST_REVIEW_START = 'BULK_PURCHASE_COST_REVIEW_START';
export const startCostReview = (
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  erroredFulfillmentPlanIds,
  andPrint,
  shouldShowLegacyCostReview = false,
) => ({
  type: BULK_PURCHASE_COST_REVIEW_START,
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  erroredFulfillmentPlanIds,
  andPrint,
  shouldShowLegacyCostReview,
});

export const BULK_PURCHASE_COST_REVIEW_OPEN = 'BULK_PURCHASE_COST_REVIEW_OPEN';
export const openCostReview = (
  jobGuid,
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  erroredFulfillmentPlanIds,
  costReviewData,
  andPrint,
  shouldShowLegacyCostReview = false,
  recommendationSummary,
  appliedSavings,
) => ({
  type: BULK_PURCHASE_COST_REVIEW_OPEN,
  jobGuid,
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  erroredFulfillmentPlanIds,
  costReviewData,
  andPrint,
  shouldShowLegacyCostReview,
  recommendationSummary,
  appliedSavings,
});

export const BULK_PURCHASE_COST_REVIEW_CANCEL = 'BULK_PURCHASE_COST_REVIEW_CANCEL';
export const cancelCostReview = (jobGuid) => ({
  type: BULK_PURCHASE_COST_REVIEW_CANCEL,
  jobGuid,
});

export const BULK_PURCHASE_END = 'BULK_PURCHASE_END';
export const endBulkPurchase = (
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  erroredFulfillmentPlanIds,
  andPrint,
  labelBatchId,
) => ({
  type: BULK_PURCHASE_END,
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  erroredFulfillmentPlanIds,
  andPrint,
  labelBatchId,
});

export const BULK_PURCHASE_SET_LBS_MODAL_ID = 'BULK_PURCHASE_SET_LBS_MODAL_ID';
export const setLbsModalId = (lbsModalId) => ({
  type: BULK_PURCHASE_SET_LBS_MODAL_ID,
  lbsModalId,
});

export const BULK_PURCHASE_RETRY_VALIDATION = 'BULK_PURCHASE_RETRY_VALIDATION';
export const retryValidation = (includedFulfillmentPlanIds) => ({
  type: BULK_PURCHASE_RETRY_VALIDATION,
  includedFulfillmentPlanIds,
});

export const BULK_CLEAR_ACTIVE_MODAL_STEP = 'BULK_CLEAR_ACTIVE_MODAL_STEP';
export const bulkClearActiveModalStep = () => ({
  type: BULK_CLEAR_ACTIVE_MODAL_STEP,
});

export const COST_REVIEW_BULK_RETRY = 'COST_REVIEW_BULK_RETRY';
export const costReviewBulkRetry = (jobGuid) => ({
  type: COST_REVIEW_BULK_RETRY,
  jobGuid,
});

export const COST_REVIEW_APPLY_RECOMMENDATIONS = 'COST_REVIEW_APPLY_RECOMMENDATIONS';
export const costReviewApplyRecommendations = ({
  costReviewJobGuid,
  bulkUpdateJobGuid,
  serviceFilters,
  insuranceFilters,
  rateShopperFilters,
  isRateShopperRecommendationsEnabled,
}) => ({
  type: COST_REVIEW_APPLY_RECOMMENDATIONS,
  jobGuid: costReviewJobGuid,
  bulkUpdateJobGuid,
  serviceFilters,
  insuranceFilters,
  rateShopperFilters,
  isRateShopperRecommendationsEnabled,
});

export const COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS = 'COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS';
export const costReviewApplyRecommendationsSuccess = (costReviewJobGuid) => ({
  type: COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS,
  jobGuid: costReviewJobGuid,
});

export const COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR = 'COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR';
export const costReviewApplyRecommendationsError = (costReviewJobGuid) => ({
  type: COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR,
  jobGuid: costReviewJobGuid,
});
